import React from 'react';

import CustomModal from 'components/CustomModal';
import { StyledTextField } from 'components/Input/styles';
import { Button } from 'components/Button';

interface WontDoModalProps {
  open: boolean;
  itemName: string;
  reason: string;
  loading: boolean;
  onReasonChange: (value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

const WontDoModal: React.FC<WontDoModalProps> = ({
  open,
  itemName,
  reason,
  loading,
  onReasonChange,
  onClose,
  onConfirm,
}) => (
  <CustomModal
    openModal={open}
    onClose={onClose}
    modalTitle="Mark As Won't Do"
    modalDescription={`You're about to mark ${itemName} as won't do. Please provide a reason.`}
    cancelButton={
      <Button disabled={loading} onClick={onClose} id="cancel-wont-do-button" variant="outlined" size="large">
        Cancel
      </Button>
    }
    submitButton={
      <Button
        onClick={onConfirm}
        disabled={!reason.trim() || loading}
        id="confirm-wont-do-button"
        variant="contained"
        size="large"
      >
        Mark as Won&apos;t Do
      </Button>
    }
  >
    <StyledTextField
      variant="outlined"
      placeholder="Enter reason here..."
      value={reason}
      onChange={(e) => onReasonChange(e.target.value)}
      multiline
      minRows={3}
      maxRows={10}
      fullWidth
    />
  </CustomModal>
);

export default WontDoModal;
